var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { EditListForm } from './EditListForm';
import { NewListForm } from './NewListForm';
import { useFormList } from './hooks/useFormList';
/**
 * `ListForm` is a generic React component designed for handling lists within forms, especially when integrating with `react-hook-form`.
 * It provides a way to manage a list of items, each of which can be a form with its own set of fields and validation rules.
 *
 * @template TData - The type of data for the form. It should extend from FieldValues of 'react-hook-form'.
 * @param {Props<TData>} props - The properties passed to the ListForm component. These include:
 * @param {CustomField[]} definitionList - Array of custom field definitions for each item in the list.
 * @param {any} defaultValues - Default values for the form fields.
 * @param {ArrayPath<TData>} path - The path to the list in the parent form data structure. Eg., 'hardwareBundle.0' for first item in hardware bundle
 * @param {number | null} activeIndex - The currently active or selected item index in the list.
 * @param {(value: number | null) => void} onIndexChange - Function to handle changes in the active item index.
 */
export const ListForm = (_a) => {
    var { path, control, getValues, definitionList, defaultValues, activeIndex, onIndexChange } = _a, otherFormProps = __rest(_a, ["path", "control", "getValues", "definitionList", "defaultValues", "activeIndex", "onIndexChange"]);
    const { list, item, onCancel, onAppend, onRemove, onUpdate, onChange, onSetValue, onReset } = useFormList({
        control,
        getValues,
        listPath: path,
        definitionList,
        activeIndex,
        onIndexChange,
        defaultValues: defaultValues || {}
    });
    return activeIndex !== null ? (_jsx(EditListForm, Object.assign({ index: activeIndex, item: list[activeIndex], path: path, definitionList: definitionList, onCancel: onCancel, onUpdate: onUpdate, onRemove: onRemove, control: control, getValues: getValues }, otherFormProps))) : (_jsx(NewListForm, { item: item, definitionList: definitionList, onChange: onChange, onSetValue: onSetValue, onAppend: onAppend, onReset: onReset }));
};
